import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import i18next from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import translations from '@insolus/commons-translations';
import { normalizeOptions, wrapCallback } from './_helpers';

var I18n = function () {
  function I18n(_options) {
    var _this = this;

    _classCallCheck(this, I18n);

    this.getFixedT = function (lng, ns) {
      return function (key) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!_this.isInitialized) {
          throw new Error("I18n was not initialized.");
        }

        var options = _objectSpread({}, opts);

        var optionHandler = _this.options.overloadTranslationOptionHandler;

        if (typeof opts !== 'object' && optionHandler) {
          for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            rest[_key - 2] = arguments[_key];
          }

          options = optionHandler([key, opts].concat(rest));
        }

        if (!options.lng && !options.lngs && lng) {
          if (typeof lng === 'string') {
            options.lng = lng;
          } else {
            options.lngs = lng;
          }
        }

        if (!options.ns && ns) {
          options.ns = ns;
        }

        return _this.t(key, options);
      };
    };

    this.t = function (keys) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!_this.isInitialized) {
        throw new Error("I18n was not initialized.");
      }

      return _this._instance.t(keys, options);
    };

    this._isAnI18nInstance = true;
    this._instance = i18next.createInstance();

    if (_options) {
      this.init(_options);
    }
  }

  _createClass(I18n, [{
    key: "isInitialized",
    get: function get() {
      return this._instance.isInitialized || false;
    }
  }, {
    key: "language",
    get: function get() {
      return this._instance.language;
    }
  }, {
    key: "languages",
    get: function get() {
      return this._instance.languages;
    }
  }, {
    key: "options",
    get: function get() {
      return this._instance.options;
    }
  }, {
    key: "store",
    get: function get() {
      return this._instance.store;
    }
  }, {
    key: "services",
    get: function get() {
      return this._instance.services;
    }
  }, {
    key: "init",
    value: function init(options) {
      var _this2 = this;

      if (options.detection !== false) {
        this._instance.use(LngDetector);
      }

      this._instance.init(normalizeOptions(options));

      Object.keys(translations).forEach(function (lng) {
        Object.keys(translations[lng]).forEach(function (ns) {
          _this2._instance.addResourceBundle(lng, ns, translations[lng][ns]);
        });
      });
      var storeApiMethods = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApiMethods.forEach(function (method) {
        _this2[method] = function () {
          var _this2$_instance$stor;

          return (_this2$_instance$stor = _this2._instance.store)[method].apply(_this2$_instance$stor, arguments);
        };
      });
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this3 = this;

      return wrapCallback(function (cb) {
        _this3._instance.changeLanguage(lng, cb);
      }, callback);
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this4 = this;

      return wrapCallback(function (cb) {
        _this4._instance.loadNamespaces(ns, cb);
      }, callback);
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var _this5 = this;

      return wrapCallback(function (cb) {
        _this5._instance.loadLanguages(lngs, cb);
      }, callback);
    }
  }], [{
    key: "isI18n",
    value: function isI18n(obj) {
      return obj instanceof I18n || !!obj._isAnI18nInstance;
    }
  }]);

  return I18n;
}();

var i18nextApiMethods = ['use', 'on', 'off', 'exists', 'reloadResources', 'setDefaultNamespace', 'dir', 'format'];
i18nextApiMethods.forEach(function (method) {
  I18n.prototype[method] = function () {
    var _this$_instance;

    var response = (_this$_instance = this._instance)[method].apply(_this$_instance, arguments);

    return response === this._instance ? this : response;
  };
});
export default I18n;